import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  left: 0px;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.19);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export const Wrapper = styled.div`
  padding: 20px;
  background: #2a3142;
  width: 100%;
  max-width: 400px;
  border-radius: 4px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.192);
  display: flex;
  align-items: center;
  flex-direction: column;
`;
